"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalRegisterEntry = PersonalRegisterEntry;
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _HomeAccordion = _interopRequireDefault(require("./components/HomeAccordion"));
var _MailAccordion = _interopRequireDefault(require("./components/MailAccordion"));
var _OtherAccordion = _interopRequireDefault(require("./components/OtherAccordion"));
var _RegisterUserInformation = _interopRequireDefault(require("./components/RegisterUserInformation"));
var _WorkAccordion = _interopRequireDefault(require("./components/WorkAccordion"));
var _personalRegisterActions = require("./personalRegisterActions");
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 個人情報設定
 */
function PersonalRegisterEntry(props) {
  var _entries$areaCd, _entries$siteOtherNm, _entries$siteOtherTdf, _entries$mailAddress, _entries$mailAddress2, _errors$areaCd, _errors$siteNo, _errors$siteOtherNm, _errors$siteOtherTdfk, _errors$mailAddress, _errors$mailAddress2;
  const {
    onBack,
    intl,
    callAPI,
    userInfo,
    entries,
    openConfirm,
    openInfoBar,
    setDirty,
    setContent,
    setEntry,
    setEntries
  } = props;
  const schemaShape = {
    workRenkeiFlg: (0, _validationHelpers.optionalBoolean)(),
    masterFlg: (0, _validationHelpers.optionalBoolean)(),
    siteListProp: (0, _validationHelpers.optionalString)(),
    areaCd: (0, _validationHelpers.requiredSelectWhen)(intl, ['workRenkeiFlg', 'masterFlg', 'siteListProp'], (wr, mf, slp) => !wr && !mf && slp === _personalRegisterActions.SITE_LIST_PROP_CODE.LIST_SEARCH),
    siteNo: (0, _validationHelpers.requiredSelectWhen)(intl, ['workRenkeiFlg', 'masterFlg', 'siteListProp'], (wr, mf, slp) => !wr && !mf && slp === _personalRegisterActions.SITE_LIST_PROP_CODE.LIST_SEARCH),
    siteOtherNm: (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, ['workRenkeiFlg', 'masterFlg', 'siteListProp'], (wr, mf, slp) => !wr && !mf && slp === _personalRegisterActions.SITE_LIST_PROP_CODE.INPUT_LIST, 255),
    siteOtherTdfkCd: (0, _validationHelpers.requiredSelectWhen)(intl, ['workRenkeiFlg', 'masterFlg', 'siteListProp'], (wr, mf, slp) => !wr && !mf && slp === _personalRegisterActions.SITE_LIST_PROP_CODE.INPUT_LIST),
    mailAddress2: (0, _validationHelpers.optionalEmail)(intl, {
      max: 100
    }),
    mailAddress3: (0, _validationHelpers.optionalEmail)(intl, {
      max: 100
    })
  };
  const {
    register,
    handleSubmit,
    setValue,
    formState: {
      errors
    }
  } = (0, _useRHFForm.useRHFForm)({
    shape: schemaShape,
    options: {
      shouldFocusError: false
    },
    defaultValues: {
      workRenkeiFlg: entries === null || entries === void 0 ? void 0 : entries.workRenkeiFlg,
      masterFlg: entries === null || entries === void 0 ? void 0 : entries.masterFlg,
      siteListProp: entries === null || entries === void 0 ? void 0 : entries.siteListProp,
      areaCd: (_entries$areaCd = entries === null || entries === void 0 ? void 0 : entries.areaCd) !== null && _entries$areaCd !== void 0 ? _entries$areaCd : '',
      siteNo: entries !== null && entries !== void 0 && entries.siteNo ? String(entries.siteNo) : '',
      siteOtherNm: (_entries$siteOtherNm = entries === null || entries === void 0 ? void 0 : entries.siteOtherNm) !== null && _entries$siteOtherNm !== void 0 ? _entries$siteOtherNm : '',
      siteOtherTdfkCd: (_entries$siteOtherTdf = entries === null || entries === void 0 ? void 0 : entries.siteOtherTdfkCd) !== null && _entries$siteOtherTdf !== void 0 ? _entries$siteOtherTdf : '',
      mailAddress2: (_entries$mailAddress = entries === null || entries === void 0 ? void 0 : entries.mailAddress2) !== null && _entries$mailAddress !== void 0 ? _entries$mailAddress : '',
      mailAddress3: (_entries$mailAddress2 = entries === null || entries === void 0 ? void 0 : entries.mailAddress3) !== null && _entries$mailAddress2 !== void 0 ? _entries$mailAddress2 : ''
    }
  });
  _react.default.useEffect(() => {
    ['workRenkeiFlg', 'masterFlg', 'siteListProp', 'areaCd', 'siteNo', 'siteOtherNm', 'siteOtherTdfkCd', 'mailAddress2', 'mailAddress3'].forEach(name => register(name));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register]);
  _react.default.useEffect(() => {
    var _entries$workRenkeiFl, _entries$masterFlg, _entries$siteListProp, _entries$areaCd2, _entries$siteOtherNm2, _entries$siteOtherTdf2, _entries$mailAddress3, _entries$mailAddress4;
    if (!entries) return;
    setValue('workRenkeiFlg', (_entries$workRenkeiFl = entries.workRenkeiFlg) !== null && _entries$workRenkeiFl !== void 0 ? _entries$workRenkeiFl : false);
    setValue('masterFlg', (_entries$masterFlg = entries.masterFlg) !== null && _entries$masterFlg !== void 0 ? _entries$masterFlg : false);
    setValue('siteListProp', (_entries$siteListProp = entries.siteListProp) !== null && _entries$siteListProp !== void 0 ? _entries$siteListProp : '');
    setValue('areaCd', (_entries$areaCd2 = entries.areaCd) !== null && _entries$areaCd2 !== void 0 ? _entries$areaCd2 : '');
    setValue('siteNo', entries.siteNo ? String(entries.siteNo) : '');
    setValue('siteOtherNm', (_entries$siteOtherNm2 = entries.siteOtherNm) !== null && _entries$siteOtherNm2 !== void 0 ? _entries$siteOtherNm2 : '');
    setValue('siteOtherTdfkCd', (_entries$siteOtherTdf2 = entries.siteOtherTdfkCd) !== null && _entries$siteOtherTdf2 !== void 0 ? _entries$siteOtherTdf2 : '');
    setValue('mailAddress2', (_entries$mailAddress3 = entries.mailAddress2) !== null && _entries$mailAddress3 !== void 0 ? _entries$mailAddress3 : '');
    setValue('mailAddress3', (_entries$mailAddress4 = entries.mailAddress3) !== null && _entries$mailAddress4 !== void 0 ? _entries$mailAddress4 : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entries]);
  const handleOpenRegisterDialogValidated = () => {
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SETTING_CONFIRM_MESSAGE
    }), onRegister);
  };
  const onRegister = () => {
    const {
      kaishaCd,
      shainId
    } = userInfo;
    const sendData = _objectSpread(_objectSpread({}, entries), {}, {
      kaishaCd: kaishaCd,
      shainId: shainId
    });
    callAPI(_APIs.PERSONAL_REGISTER, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setDirty(false);
        setEntries(response.data);
        setContent(_personalRegisterActions.CONTENTS.RESULT);
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    });
  };
  const onInvalid = () => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, entries.loadingStatus === _personalRegisterActions.LOADING_STATUS.NOW_LOADING && /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    fixedWidth: true,
    title: intl.formatMessage({
      id: _labelConsts.LABEL.USERCUSTOM_PERSONAL_REGISTER_INPUT
    })
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_RegisterUserInformation.default, {
    userInfo: userInfo
  }), intl.formatMessage({
    id: _labelConsts.LABEL.CORE_LOADING_MESSAGE
  }))), entries.loadingStatus === _personalRegisterActions.LOADING_STATUS.DATA_COMPLETED && /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(handleOpenRegisterDialogValidated, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    fixedWidth: true,
    title: intl.formatMessage({
      id: _labelConsts.LABEL.USERCUSTOM_PERSONAL_REGISTER_INPUT
    }),
    help: /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: _labelConsts.LABEL.USERCUSTOM_USERCUSTOM_HELP
    }),
    actions: [/*#__PURE__*/_react.default.createElement(_CButton.default, {
      negative: true,
      onClick: onBack,
      autoWidth: true,
      key: "back"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_HOME
    })), /*#__PURE__*/_react.default.createElement(_CButton.default, {
      submit: true,
      key: "submit"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIGURATION
    }))]
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_RegisterUserInformation.default, {
    userInfo: userInfo
  }), /*#__PURE__*/_react.default.createElement(_WorkAccordion.default, {
    setEntry: setEntry,
    onChangeAreaSite: obj => {
      // tdfkCd を entries.workTdfkCd に反映する（都道府県の表示用）
      const {
        areaCd,
        siteNo,
        siteBuildingNm,
        tdfkCd
      } = obj;
      setDirty(true);
      setEntries({
        areaCd,
        siteNo,
        siteBuildingNm,
        workTdfkCd: tdfkCd
      });
      setValue('areaCd', areaCd !== null && areaCd !== void 0 ? areaCd : '');
      setValue('siteNo', siteNo ? String(siteNo) : '');
    },
    areaCdError: (_errors$areaCd = errors.areaCd) === null || _errors$areaCd === void 0 ? void 0 : _errors$areaCd.message,
    siteNoError: (_errors$siteNo = errors.siteNo) === null || _errors$siteNo === void 0 ? void 0 : _errors$siteNo.message,
    siteOtherNmError: (_errors$siteOtherNm = errors.siteOtherNm) === null || _errors$siteOtherNm === void 0 ? void 0 : _errors$siteOtherNm.message,
    siteOtherTdfkCdError: (_errors$siteOtherTdfk = errors.siteOtherTdfkCd) === null || _errors$siteOtherTdfk === void 0 ? void 0 : _errors$siteOtherTdfk.message
  }), /*#__PURE__*/_react.default.createElement(_HomeAccordion.default, {
    setEntry: setEntry
  }), /*#__PURE__*/_react.default.createElement(_OtherAccordion.default, {
    setEntry: setEntry
  }), /*#__PURE__*/_react.default.createElement(_MailAccordion.default, {
    setEntry: key => value => {
      setDirty(true);
      setEntry(key)(value);
      if (key === 'mailAddress2') setValue('mailAddress2', value !== null && value !== void 0 ? value : '');
      if (key === 'mailAddress3') setValue('mailAddress3', value !== null && value !== void 0 ? value : '');
    },
    mailAddress2Error: (_errors$mailAddress = errors.mailAddress2) === null || _errors$mailAddress === void 0 ? void 0 : _errors$mailAddress.message,
    mailAddress3Error: (_errors$mailAddress2 = errors.mailAddress3) === null || _errors$mailAddress2 === void 0 ? void 0 : _errors$mailAddress2.message
  })))));
}
PersonalRegisterEntry.propTypes = {
  // Parent
  onBack: _propTypes.default.func,
  // injectIntl
  intl: _propTypes.default.object,
  // withCallAPI
  callAPI: _propTypes.default.func,
  // State
  userInfo: _propTypes.default.object,
  entries: _propTypes.default.object,
  // Dispatch
  openConfirm: _propTypes.default.func,
  openInfoBar: _propTypes.default.func,
  setDirty: _propTypes.default.func,
  setContent: _propTypes.default.func,
  setEntry: _propTypes.default.func,
  setEntries: _propTypes.default.func
};
const mapStateToProps = state => {
  return {
    userInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    entries: state.personalRegister.entries
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    setDirty: dirty => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](dirty)),
    setContent: content => dispatch(_personalRegisterActions.personalRegisterActions[_personalRegisterActions.TYPES.SET_CONTENT](content)),
    setEntry: key => value => dispatch(_personalRegisterActions.personalRegisterActions[_personalRegisterActions.TYPES.SET_ENTRY](key, value)),
    setEntries: entries => dispatch(_personalRegisterActions.personalRegisterActions[_personalRegisterActions.TYPES.SET_ENTRIES](entries))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(PersonalRegisterEntry)));